export type Voice = {
  quote: string
  author: string
  source: string
}

/**
 * VOC real (ficha DPS66, sección 2.3): frases textuales de técnicos y fuentes
 * del oficio, con su fuente. NO son reseñas del producto y la página lo aclara.
 */
export const techVoices: Voice[] = [
  {
    quote: 'Ice machines are very time consuming to clean, service, and repair',
    author: 'A commercial refrigeration service owner',
    source: 'ACHR News, 2015',
  },
  {
    quote: 'A lot of guys say it’s usually all the calcium build up.',
    author: 'A refrigeration tech on an undercounter call',
    source: 'r/refrigeration, 2024',
  },
  {
    quote: 'you probably won’t understand it without a substantial investment.',
    author: 'On reading an ice machine service manual',
    source: 'eTech, 2023',
  },
]

export const moreTechVoices: Voice[] = [
  {
    quote: 'You cannot troubleshoot without knowing the sequence of operation',
    author: 'A commercial refrigeration tech',
    source: 'ACHR News, 2016',
  },
  {
    quote: 'common repairs on ice machines are due to water filters not being changed.',
    author: 'A commercial refrigeration service owner',
    source: 'ACHR News, 2015',
  },
  {
    quote: 'at a frequency necessary to preclude accumulation of soil or mold',
    author: 'Food code language inspectors cite on ice makers',
    source: 'FDACS 4-602.11(E)',
  },
]
